import {
    FaMapMarkerAlt,
    FaWifi,
    FaSwimmingPool,
    FaDumbbell,
    FaSpa,
    FaUtensils,
    FaConciergeBell,
    FaCar,
    FaKey,
    FaBriefcase,
    FaClock,
    FaPlane,
    FaBuilding,
    FaCoffee,
    FaArrowRight,
    FaStar,
} from "react-icons/fa";

import styles from "./Page.module.css";

const DestinationPage = () => {
    const openLink = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const amenities = [
        {
            icon: <FaWifi />,
            title: "Free Wi-Fi",
            text: "Stay connected throughout your visit.",
        },
        {
            icon: <FaSwimmingPool />,
            title: "Rooftop Pool",
            text: "Relax and unwind with a refreshing swim.",
        },
        {
            icon: <FaDumbbell />,
            title: "Fitness Center",
            text: "Keep up with your fitness routine during your stay.",
        },
        {
            icon: <FaSpa />,
            title: "Spa",
            text: "Enjoy a relaxing wellness experience.",
        },
        {
            icon: <FaUtensils />,
            title: "Dining",
            text: "Enjoy multiple dining and drink options.",
        },
        {
            icon: <FaConciergeBell />,
            title: "Concierge",
            text: "Personalized assistance whenever you need it.",
        },
        {
            icon: <FaCar />,
            title: "Valet Parking",
            text: "Complimentary valet parking is available.",
        },
        {
            icon: <FaKey />,
            title: "Digital Key",
            text: "Enjoy convenient digital access during your stay.",
        },
    ];

    const nearbyPlaces = [
        {
            distance: "8 km",
            title: "Mall of Asia",
            text: "Shopping, dining and entertainment.",
        },
        {
            distance: "9.5 km",
            title: "Bengaluru City Center",
            text: "Explore the city's central attractions.",
        },
        {
            distance: "11 km",
            title: "Bangalore Palace",
            text: "Discover one of Bengaluru's iconic landmarks.",
        },
        {
            distance: "16 km",
            title: "Tipu Sultan's Summer Palace",
            text: "A historic destination in the heart of Bengaluru.",
        },
    ];

    return (
        <main className={styles.destinationPage}>
            {/* HERO */}
            <section
                className={styles.hero}
                style={{ backgroundImage: "url(/images/hilton-venue.avif)" }}
            >
                <div className={styles.heroOverlay}></div>

                <div className="container position-relative">
                    <div className={styles.heroContent}>
                        <div className={styles.locationBadge}>
                            <FaMapMarkerAlt />
                            Bengaluru, Karnataka
                        </div>

                        <h1>
                            Hilton Bengaluru Embassy
                            <span> Manyata Business Park</span>
                        </h1>

                        <p>
                            Modern comfort and refined hospitality at the
                            gateway to Manyata Business Park.
                        </p>

                        <div className={styles.heroActions}>
                            <button
                                className={styles.primaryBtn}
                                onClick={() =>
                                    openLink(
                                        "https://www.hilton.com/en/hotels/blrgshi-hilton-bengaluru-embassy-manyata-business-park/"
                                    )
                                }
                            >
                                Explore Hotel
                                <FaArrowRight />
                            </button>

                            <a
                                href="#location"
                                className={styles.secondaryBtn}
                            >
                                View Location
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* INTRO */}
            <section className={styles.introSection}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-7">
                            <span className={styles.sectionLabel}>
                                THE DESTINATION
                            </span>

                            <h2 className={styles.sectionTitle}>
                                A refined stay in the heart of North Bengaluru
                            </h2>

                            <p className={styles.leadText}>
                                Hilton Bengaluru Embassy Manyata Business Park
                                combines contemporary hospitality with a
                                convenient location at the entrance of Manyata
                                Business Park.
                            </p>

                            <p className={styles.bodyText}>
                                The hotel is positioned close to Karle Town
                                Centre and offers convenient access to Hebbal,
                                Bhartiya City, Brigade Magnum, Brigade Opus
                                and other destinations across North Bengaluru.
                            </p>

                            <div className={styles.infoRow}>
                                <div>
                                    <FaBuilding />
                                    <strong>Manyata Business Park</strong>
                                    <span>Gateway location</span>
                                </div>

                                <div>
                                    <FaPlane />
                                    <strong>30 min</strong>
                                    <span>Approx. airport drive</span>
                                </div>

                                <div>
                                    <FaClock />
                                    <strong>3 PM / 12 PM</strong>
                                    <span>Check-in / Check-out</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className={styles.hotelCard}>
                                <div className={styles.hotelCardTop}>
                                    <div className={styles.hotelIcon}>
                                        <FaBuilding />
                                    </div>

                                    <div>
                                        <h3>Hilton Bengaluru</h3>
                                        <p>Embassy Manyata Business Park</p>
                                    </div>
                                </div>

                                <div className={styles.rating}>
                                    <FaStar />
                                    <FaStar />
                                    <FaStar />
                                    <FaStar />
                                    <FaStar />
                                    <span>Premium Hilton experience</span>
                                </div>

                                <div className={styles.address}>
                                    <FaMapMarkerAlt />
                                    <span>
                                        Block A, Hotel Building-1,
                                        <br />
                                        Outer Ring Road, Nagavara,
                                        <br />
                                        Bengaluru - 560045
                                    </span>
                                </div>

                                <button
                                    className={styles.outlineBtn}
                                    onClick={() =>
                                        openLink(
                                            "https://www.hilton.com/en/hotels/blrgshi-hilton-bengaluru-embassy-manyata-business-park/"
                                        )
                                    }
                                >
                                    Visit Hilton Website
                                    <FaArrowRight />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* HOTEL FEATURES */}
            <section className={styles.featuresSection}>
                <div className="container">
                    <div className={styles.sectionHeading}>
                        <span className={styles.sectionLabel}>
                            HOTEL FEATURES
                        </span>

                        <h2 className={styles.sectionTitle}>
                            Everything you need for a comfortable stay
                        </h2>

                        <p>
                            From wellness and dining to business facilities and
                            convenient guest services, enjoy a complete hotel
                            experience.
                        </p>
                    </div>

                    <div className="row g-4">
                        {amenities.map((item, index) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={index}>
                                <div className={styles.amenityCard}>
                                    <div className={styles.amenityIcon}>
                                        {item.icon}
                                    </div>

                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* HOTEL EXPERIENCE */}
            <section className={styles.experienceSection}>
                <div className="container">
                    <div className="row align-items-stretch g-0">
                        <div className="col-lg-6">
                            <div
                                className={styles.experienceImage}
                                style={{
                                    backgroundImage:
                                        "url(/images/venue.jpg)",
                                }}
                            />
                        </div>

                        <div className="col-lg-6">
                            <div className={styles.experienceContent}>
                                <span className={styles.sectionLabel}>
                                    HOTEL EXPERIENCE
                                </span>

                                <h2>
                                    Designed for business,
                                    relaxation and memorable stays
                                </h2>

                                <p>
                                    Whether you are visiting Bengaluru for
                                    business or leisure, Hilton Bengaluru
                                    Embassy Manyata Business Park offers a
                                    comfortable base with dining, wellness,
                                    recreation and event facilities.
                                </p>

                                <div className={styles.experienceList}>
                                    <div>
                                        <FaUtensils />
                                        <span>
                                            <strong>Dining & Drinks</strong>
                                            Neo Kitchen, Neer restaurant and
                                            Double Up bar.
                                        </span>
                                    </div>

                                    <div>
                                        <FaSpa />
                                        <span>
                                            <strong>Wellness</strong>
                                            Spa facilities and a fitness center
                                            for relaxation and wellness.
                                        </span>
                                    </div>

                                    <div>
                                        <FaBriefcase />
                                        <span>
                                            <strong>Meetings & Events</strong>
                                            Flexible spaces for business and
                                            social occasions.
                                        </span>
                                    </div>

                                    <div>
                                        <FaCoffee />
                                        <span>
                                            <strong>Comfort & Convenience</strong>
                                            Room service, concierge and Digital
                                            Key facilities.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ROOMS */}
            <section className={styles.roomsSection}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <span className={styles.sectionLabel}>
                                ROOMS & SUITES
                            </span>

                            <h2 className={styles.sectionTitle}>
                                A comfortable space to recharge
                            </h2>

                            <p className={styles.leadText}>
                                Settle into thoughtfully designed guest rooms
                                and suites with the comfort and services
                                expected from Hilton.
                            </p>

                            <div className={styles.roomHighlights}>
                                <span>✓ Free Wi-Fi</span>
                                <span>✓ Non-smoking rooms</span>
                                <span>✓ Connecting rooms</span>
                                <span>✓ Room service</span>
                                <span>✓ Digital Key</span>
                                <span>✓ Executive lounge</span>
                            </div>

                            <button
                                className={styles.darkBtn}
                                onClick={() =>
                                    openLink(
                                        "https://www.hilton.com/en/hotels/blrgshi-hilton-bengaluru-embassy-manyata-business-park/rooms/"
                                    )
                                }
                            >
                                Explore Rooms
                                <FaArrowRight />
                            </button>
                        </div>

                        <div className="col-lg-5">
                            <div className={styles.roomQuote}>
                                <span>YOUR STAY</span>
                                <h3>
                                    Modern hospitality with Bengaluru at your
                                    doorstep.
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* LOCATION */}
            <section
                className={styles.locationSection}
                id="location"
            >
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-5">
                            <span className={styles.sectionLabel}>
                                LOCATION
                            </span>

                            <h2 className={styles.sectionTitle}>
                                Well connected to Bengaluru
                            </h2>

                            <p className={styles.bodyText}>
                                Located at the entrance of Embassy Manyata
                                Business Park, the hotel provides convenient
                                access to business districts, shopping,
                                dining and major attractions.
                            </p>

                            <div className={styles.locationDetails}>
                                <div>
                                    <FaMapMarkerAlt />
                                    <span>
                                        <strong>Address</strong>
                                        Block A, Hotel Building-1,
                                        Outer Ring Road, Nagavara,
                                        Bengaluru 560045
                                    </span>
                                </div>

                                <div>
                                    <FaPlane />
                                    <span>
                                        <strong>Airport</strong>
                                        Kempegowda International Airport —
                                        approximately 30 km
                                    </span>
                                </div>
                            </div>

                            <button
                                className={styles.darkBtn}
                                onClick={() =>
                                    openLink(
                                        "https://www.google.com/maps/search/?api=1&query=Hilton+Bengaluru+Embassy+Manyata+Business+Park"
                                    )
                                }
                            >
                                Get Directions
                                <FaArrowRight />
                            </button>
                        </div>

                        <div className="col-lg-7">
                            <div className={styles.mapWrapper}>
                                <iframe
                                    title="Hilton Bengaluru Embassy Manyata Business Park Map"
                                    src="https://www.google.com/maps?q=Hilton%20Bengaluru%20Embassy%20Manyata%20Business%20Park&output=embed"
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* NEARBY */}
            <section className={styles.nearbySection}>
                <div className="container">
                    <div className={styles.sectionHeading}>
                        <span className={styles.sectionLabel}>
                            EXPLORE NEARBY
                        </span>

                        <h2 className={styles.sectionTitle}>
                            Discover North Bengaluru
                        </h2>

                        <p>
                            Explore shopping, landmarks and city experiences
                            within convenient reach of the hotel.
                        </p>
                    </div>

                    <div className="row g-4">
                        {nearbyPlaces.map((place, index) => (
                            <div
                                className="col-12 col-sm-6 col-lg-3"
                                key={index}
                            >
                                <div className={styles.nearbyCard}>
                                    <div className={styles.distance}>
                                        {place.distance}
                                    </div>

                                    <h3>{place.title}</h3>

                                    <p>{place.text}</p>

                                    <FaArrowRight
                                        className={styles.nearbyArrow}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className={styles.ctaSection}>
                <div className="container">
                    <div className={styles.ctaBox}>
                        <div>
                            <span>PLAN YOUR STAY</span>

                            <h2>
                                Experience Hilton Bengaluru Embassy Manyata
                            </h2>

                            <p>
                                Discover modern comfort, convenient
                                connectivity and thoughtful hospitality in
                                North Bengaluru.
                            </p>
                        </div>

                        <button
                            className={styles.ctaButton}
                            onClick={() =>
                                openLink(
                                    "https://www.hilton.com/en/hotels/blrgshi-hilton-bengaluru-embassy-manyata-business-park/"
                                )
                            }
                        >
                            View Hotel
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default DestinationPage;